import SoftwareSolutionCard from "./SoftwareSolutionCard";
import web_and_dev from "../assets/svgs/software-solutions/web-and_dev.svg";
import customer_dev_solution from "../assets/svgs/software-solutions/customer-dev-solution.svg";
import colud_solution from "../assets/svgs/software-solutions/cloud-solution.svg";
import ai_and_machine_leaning_solution from "../assets/svgs/software-solutions/ai-and-machine-learning.svg";
// import cyber_security_solution from "../assets/svgs/software-solutions/cyber-security.svg";
import { Carousel } from "./AIAutomationCarousel";

const cardList = [
  {
    title: <>الذكاء الاصطناعي وتعلم الآلة</>,
    description: (
      <>
        حافظ على مركزك في الريادة مع خدمات الذكاء الاصطناعي وتعلُّم الآلة بفضل
        حلولنا الذكية التي نطورها والتي
      </>
    ),
    parentClass: "",
    positionClass: "ml-[35px] mb-[1.3em] transform -rotate-6 mt-[77px]",
    image: ai_and_machine_leaning_solution,
    tooltip: (
      <span dir="rtl">
        حافظ على مركزك في الريادة مع خدمات الذكاء الاصطناعي وتعلُّم الآلة بفضل
        حلولنا الذكية التي نطورها والتي تعمل على أتمتة العمليات وتحليل البيانات
        وتقديم رؤى قيمة لدفع عملية اتخاذ القرارات المستنيرة.
      </span>
    ),
    bgColor: "#FFF",
    titleColor: "#111748",
    descriptionColorClass: "text-[#111748]",
    titleHeightClass: "",
  },
  {
    title: <>تطوير تطبيقات الويب والهاتف المحمول </>,
    description: (
      <>
        نحن متخصصون في تصميم تطبيقات ويب وتطبيقات جوال سريعة الاستجابة وذكية
        وسهلة الاستخدام عن طريق الاستفادة من{" "}
      </>
    ),
    parentClass: "",
    positionClass: "rotate-1.5 z-20",
    image: web_and_dev,
    bgColor: "#111748",
    tooltip: (
      <span dir="rtl">
        نحن متخصصون في تصميم تطبيقات ويب وتطبيقات جوال سريعة الاستجابة وذكية
        وسهلة الاستخدام عن طريق الاستفادة من أحدث التقنيات ومن الذكاء الاصطناعي.
        فإن حلولنا تستعين بالذكاء الاصطناعي لتحسين تجربة المستخدم ولأتمتة
        العمليات وتحويل طريقة تفاعل شركتك مع العملاء سواء كان هذا على نظام
        التشغيل iOS أو Android أو عبر الأنظمة الأساسية.
      </span>
    ),
  },
  {
    title: <>حلول السحابة </>,
    description: (
      <>
        استمتع بقابلية التوسع والمرونة التي توفرها السحابة من خلال حلولنا
        السحابية المصممة على يد أصحاب الخبرات. بدءًا من مرحلة
      </>
    ),
    parentClass: "",
    positionClass: "rotate-3 ml-5 mt-5 z-10",
    image: colud_solution,
    tooltip: (
      <span dir="rtl">
        استمتع بقابلية التوسع والمرونة التي توفرها السحابة من خلال حلولنا
        السحابية المصممة على يد أصحاب الخبرات. بدءًا من مرحلة الترحيل إلى مرحلة
        التحسين، نعمل على تمكين الشركات بحيث تستفيد من الإمكانات الكاملة للحوسبة
        السحابية.
      </span>
    ),
    bgColor: "#FFC641",
    titleColor: "#111748",
    descriptionColorClass: "text-[#111748]",
    titleHeightClass: "h-[80px] pb-10",
  },
  {
    title: <>تطوير البرامج المخصصة</>,
    description: (
      <>
        يبرع فريقنا المكون من مطورين متمرسين في إنشاء حلول مخصصة للبرامج، والتي
        تهدف إلى تلبية الاحتياجات والتحديات الخاصة
      </>
    ),
    parentClass: "",
    positionClass: "rotate-[8deg] mt-[26px]",
    image: customer_dev_solution,
    tooltip: (
      <span dir="rtl">
        يبرع فريقنا المكون من مطورين متمرسين في إنشاء حلول مخصصة للبرامج، والتي
        تهدف إلى تلبية الاحتياجات والتحديات الخاصة التي يواجهها عملاؤنا. ومن
        مرحلة تكوين الفكرة في الذهن إلى مرحلة الإطلاق، نضمن عملية تطوير تتسم
        بالسلاسة والفاعلية.
      </span>
    ),
    bgColor: "#fff",
    titleColor: "#111748",
    descriptionColorClass: "text-[#111748]",
  },

  // {
  //   title: <>الأمن الإلكتروني </>,
  //   description: (
  //     <>احمِ أصولك الرقمية من خلال خدمات الأمن الإلكتروني الفعالة لدينا. </>
  //   ),
  //   parentClass: "",
  //   positionClass: "mr-[35px] rotate-[1.54deg] mt-[10px]",
  //   image: cyber_security_solution,
  //   tooltip: (
  //     <span dir="rtl">
  //       نحن ننفذ أحدث التدابير للحماية من التهديدات الإلكترونية وضمان سرية
  //       بياناتك وسلامتها وتوافرها.
  //     </span>
  //   ),
  //   bgColor: "#111748",
  //   titleColor: "#FFFFFFE6",
  //   descriptionColorClass: "text-[#FFFFFFE6]",
  //   titleHeightClass: "h-[80px] pb-10",
  // },
];

const SoftwareSolutionsCardsSection = () => {
  return (
    // <div className="relative flex-grow overflow-x-auto hide-scroll-bar overflow-y-hidden">
    <Carousel
      // isSoftwareSolutions={true}
      dataSize={cardList.length}
      shadowLeft={true}
      shadowRight={true}
    >
      {cardList.map((card, i) => (
        <SoftwareSolutionCard
          key={i}
          title={card.title}
          description={card.description}
          parentClass={`${card.parentClass} ${card.positionClass}`}
          image={card.image}
          tooltip={card.tooltip}
          bgColor={card.bgColor}
          descriptionColorClass={card.descriptionColorClass}
          titleColor={card.titleColor}
          titleHeightClass={card.titleHeightClass}
        />
      ))}
    </Carousel>
    // </div>
  );
};

export default SoftwareSolutionsCardsSection;
